import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import type { UpdateManageAccessPayload } from '@/types/manage-access.types';
import type { UpdateParticipantsResponseDTO } from '@/types/SixDetailDTOs';
import { createSixUpdatedMessage } from '@/types/poc/messageFactory';
import { fetchParticipantsThunk } from '@/store/thunks/sixDetail/fetchParticipantsThunk';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';
import { publishOrgGlobalMessageThunk } from '@/store/thunks/poc/messaging/publishOrgGlobalMessageThunk';
export type { UpdateManageAccessPayload };

/** sixId (path param) + request body fields */
type UpdateManageAccessThunkArg = { sixId: string } & UpdateManageAccessPayload;

export const updateManageAccessThunk = createAppAsyncThunk<
  UpdateParticipantsResponseDTO,
  UpdateManageAccessThunkArg
>(
  'manageAccess/updateManageAccessThunk',
  withLoader(
    async({ sixId, ...body }: UpdateManageAccessThunkArg, { extra, dispatch }) => {
      const response = await extra.sixDetailService.updateSixParticipants(sixId, body);
      await dispatch(fetchParticipantsThunk(sixId));
      await dispatch(facilitateFileKeys());
      void dispatch(publishOrgGlobalMessageThunk({
        message: createSixUpdatedMessage(),
      }));
      return response;
    }
  )
);
